import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type PumpParamsChangePayload = {
  modification?: number;
  status?: number;
  low_insulin_threshold?: number;
  cannula_prime_size?: number;
  is_feature_locked?: number;
  auto_shutdown_enabled?: number;
  oled_timeout?: number;
  auto_shutdown_duration?: number;
};

export type PumpParamsChangeEvent = {
  modification?: number;
  status?: number;
  lowInsulinThreshold?: number;
  cannulaPrimeSize?: number;
  isFeatureLocked?: number;
  autoShutdownEnabled?: number;
  oledTimeout?: number;
  autoShutdownDuration?: number;
};

const pumpParamsChangeSchema = z.object({
  modification: cz.permissive(z.number()),
  status: cz.permissive(z.number()),
  low_insulin_threshold: cz.permissive(z.number()),
  cannula_prime_size: cz.permissive(z.number()),
  is_feature_locked: cz.permissive(z.number()),
  auto_shutdown_enabled: cz.permissive(z.number()),
  oled_timeout: cz.permissive(z.number()),
  auto_shutdown_duration: cz.permissive(z.number()),
});

export const LID_PARAM_PUMP_SETTINGS = {
  value: 0x49,
  name: "Pump Parameter Change Event",
  format: "b.hbbbb.bh....",
  fields: [
    "modification",
    "status",
    "low_insulin_threshold",
    "cannula_prime_size",
    "is_feature_locked",
    "auto_shutdown_enabled",
    "oled_timeout",
    "auto_shutdown_duration",
  ],
  postprocess: rec => ({
    modification: rec.modification,
    status: rec.status,
    lowInsulinThreshold: rec.low_insulin_threshold,
    cannulaPrimeSize: rec.cannula_prime_size ? rec.cannula_prime_size * 0.01 : undefined,
    isFeatureLocked: rec.is_feature_locked,
    autoShutdownEnabled: rec.auto_shutdown_enabled,
    oledTimeout: rec.oled_timeout ? rec.oled_timeout * 1000 : undefined,
    autoShutdownDuration: rec.auto_shutdown_duration ? rec.auto_shutdown_duration * 60 * 1000 * 60 : undefined,
  }),
  schema: pumpParamsChangeSchema,
} as const satisfies TandemEventDefinition<PumpParamsChangePayload, PumpParamsChangeEvent>;
